'use client';

import { useState, useEffect } from 'react';
import {
  type AppModeConfig,
  getAppMode,
  getAppModeConfig,
  getEffectiveAppMode,
} from './app-mode';

/**
 * Hydration-safe hook that returns the current AppModeConfig.
 *
 * On the server and during the first client render it uses the env-only
 * base mode (no cookie), so the HTML matches. After mount it reads the
 * cookie and re-renders if the mode differs.
 */
export function useAppModeConfig(): AppModeConfig {
  const [config, setConfig] = useState<AppModeConfig>(() =>
    getAppModeConfig(getAppMode())
  );

  useEffect(() => {
    const effective = getEffectiveAppMode();
    setConfig((prev) => (prev.mode === effective ? prev : getAppModeConfig(effective)));
  }, []);

  return config;
}
